import useActivityAcknowledgementContext from '/druid/private/useContext';

export default function useMarkAllAsAcknowledged(): () => void {
  return useActivityAcknowledgementContext().markAllAsAcknowledged;
}
